/*
 * Tempus — small, dependency-free enhancements on top of Prestige.
 * Modules: money, lazy videos, reveal, countdown, announcement, reel modal,
 *          bundle selector (Buy 3, Pay for 2), MB WAY express, sticky ATC.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ money */
  function formatMoney(cents) {
    try {
      var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
      if (cur) return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format((Number(cents) || 0) / 100);
    } catch (e) {}
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var value = (Number(cents) || 0) / 100;
    function split(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return split(value, 2, ',', '.');
        case 'amount_no_decimals': return split(value, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return split(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return split(value, 2, "'", '.');
        case 'amount_with_space_separator': return split(value, 2, ' ', ',');
        default: return split(value, 2, '.', ',');
      }
    });
  }

  /* ----------------------------------------------------------- lazy videos */
  function initLazyVideos(root) {
    var videos = (root || document).querySelectorAll('video[data-lazy-autoplay]');
    if (!videos.length) return;
    var play = function (v) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if (!('IntersectionObserver' in window)) { videos.forEach(play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { threshold: 0.15 });
    videos.forEach(function (v) { io.observe(v); });
  }

  /* ---------------------------------------------------------------- reveal */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-tmp-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------- countdown */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-tempus-countdown]').forEach(function (el) {
      if (el._tmpTimer) clearInterval(el._tmpTimer);
      var mode = el.getAttribute('data-mode');
      var deadline = el.getAttribute('data-deadline');
      var tz = el.getAttribute('data-tz');
      var inZone = function (str, zone) { // 'YYYY-MM-DDTHH:MM' wall-clock time in `zone` -> Date
        var guess = new Date(str.replace(' ', 'T') + (str.length <= 16 ? ':00' : '') + 'Z');
        if (isNaN(guess.getTime())) return guess;
        try {
          var parts = new Intl.DateTimeFormat('en-US', { timeZone: zone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(guess).reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
          var asUTC = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
          return new Date(guess.getTime() - (asUTC - guess.getTime()));
        } catch (e) { return new Date(str); }
      };
      var end = mode === 'deadline' && deadline ? (tz ? inZone(deadline, tz) : new Date(deadline)) : null;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var hide = function () {
        var target = el.getAttribute('data-hide-target');
        (target ? document.querySelector(target) || el : el).style.display = 'none';
      };
      if (mode === 'deadline' && (!end || isNaN(end.getTime()))) { hide(); return; }
      var tick = function () {
        var now = new Date();
        var target = end || new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
        var diff = Math.floor((target - now) / 1000);
        if (diff <= 0) {
          if (el.hasAttribute('data-hide-expired')) { hide(); clearInterval(el._tmpTimer); return; }
          diff = 0;
        }
        var d = Math.floor(diff / 86400), h = Math.floor((diff % 86400) / 3600);
        var dEl = el.querySelector('[data-d]');
        if (dEl) {
          if (d > 0) { dEl.hidden = false; dEl.textContent = d + 'd '; } else { dEl.hidden = true; }
        } else { h += d * 24; }
        el.querySelector('[data-h]').textContent = pad(h);
        el.querySelector('[data-m]').textContent = pad(Math.floor((diff % 3600) / 60));
        el.querySelector('[data-s]').textContent = pad(diff % 60);
      };
      tick();
      el._tmpTimer = setInterval(tick, 1000);
    });
  }

  /* ---------------------------------------------------------- announcement */
  function initAnnouncement(root) {
    (root || document).querySelectorAll('[data-tempus-ann]').forEach(function (bar) {
      var msgs = bar.querySelectorAll('.TmpAnn__Msg');
      if (bar._tmpRotate) clearInterval(bar._tmpRotate);
      if (msgs.length < 2) return;
      var i = 0;
      bar._tmpRotate = setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, parseInt(bar.getAttribute('data-interval'), 10) || 4000);
    });
  }

  /* ------------------------------------------------------------ video reel */
  function initReels(root) {
    (root || document).querySelectorAll('[data-tmp-reel]').forEach(function (reel) {
      var modal = reel.querySelector('.TmpReel__Modal');
      var player = reel.querySelector('.TmpReel__Player');
      if (!modal || !player) return;
      var close = function () { player.pause(); player.removeAttribute('src'); modal.hidden = true; document.documentElement.classList.remove('tmp-lock'); };
      reel.querySelectorAll('.TmpReel__Card').forEach(function (card) {
        card.addEventListener('click', function () {
          player.src = card.getAttribute('data-src');
          modal.hidden = false;
          document.documentElement.classList.add('tmp-lock');
          var p = player.play(); if (p && p.catch) p.catch(function () {});
        });
      });
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.TmpReel__Close')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    });
  }

  /* ------------------------------------------------------------- cart utils */
  function addItems(items, sections) {
    var body = { items: items };
    return fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var err = new Error(data && data.description || 'error'); err.userFacing = !!(data && data.description); throw err; }
        return data;
      });
    });
  }

  function openCartDrawer(variantId) {
    if (window.theme && document.getElementById('sidebar-cart')) {
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { variant: { id: variantId }, quantity: 1 }
      }));
    } else {
      window.location.href = (window.routes && window.routes.cartUrl) || '/cart';
    }
  }

  function currentVariantId(scope) {
    var form = scope && scope.closest('form');
    var input = (form || document).querySelector('[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  /* ----------------------------------------------------------- bundle (B2G1) */
  function initBundles(root) {
    (root || document).querySelectorAll('[data-tempus-bundle]').forEach(function (el) {
      if (el._tmpBundle) return;
      el._tmpBundle = true;
      var cfgEl = el.querySelector('[data-bundle-config]');
      if (!cfgEl) return;
      var cfg = JSON.parse(cfgEl.textContent);
      var L = cfg.labels;
      var state = {
        option: el.querySelector('.TmpBundle__Option.is-active').getAttribute('data-option'),
        slot: null,
        collection: cfg.defaultCollection,
        cache: {},
        slots: { 1: { id: cfg.variantId, price: cfg.price, title: cfg.productTitle, img: cfg.image }, 2: null, 3: null },
        available: cfg.available
      };
      var submit = el.querySelector('[data-bundle-submit]');
      var msg = el.querySelector('[data-bundle-msg]');
      var picker = el.querySelector('[data-picker]');
      var list = el.querySelector('[data-picker-list]');
      var chips = el.querySelector('[data-picker-chips]');

      // Move the picker to <body> so it is never clipped by sticky/overflow containers
      document.body.appendChild(picker);

      function updatePrices() {
        var picked = [state.slots[1], state.slots[2], state.slots[3]];
        var full = picked.every(Boolean);
        var prices = full ? picked.map(function (s) { return s.price; }) : [state.slots[1].price, state.slots[1].price, state.slots[1].price];
        prices.sort(function (a, b) { return a - b; });
        // Tempus rule (Black Month): reference price = 2.5× each watch (−60%); the cheapest of the three is free
        var reference = Math.round((prices[0] + prices[1] + prices[2]) * 2.5);
        var paid = prices[1] + prices[2];
        var save = Math.ceil((reference - paid) / 10) * 10;
        el.querySelector('[data-bundle-price]').textContent = formatMoney(paid);
        el.querySelector('[data-bundle-compare]').textContent = formatMoney(reference);
        el.querySelector('[data-bundle-save]').textContent = L.save + ' ' + formatMoney(save);
        el.querySelector('[data-single-price]').textContent = formatMoney(state.slots[1].price);
        var singleRef = el.querySelector('[data-single-compare]');
        if (singleRef) singleRef.textContent = formatMoney(Math.round(state.slots[1].price * 2.5));
      }

      function updateButton() {
        if (!state.available) { submit.disabled = true; submit.textContent = L.soldOut; return; }
        if (state.option === 'single') { submit.disabled = false; submit.textContent = L.addToCart; return; }
        var ready = state.slots[2] && state.slots[3];
        // Never looks disabled: while the bundle is incomplete the CTA opens the picker on the next empty slot
        submit.disabled = false;
        submit.classList.toggle('is-pending', !ready);
        submit.textContent = ready ? L.bundleCta : L.chooseWatches;
      }

      function select(option) {
        state.option = option;
        el.querySelectorAll('.TmpBundle__Option').forEach(function (o) {
          var on = o.getAttribute('data-option') === option;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        updateButton();
      }

      el.querySelectorAll('.TmpBundle__Option').forEach(function (o) {
        o.addEventListener('click', function (e) {
          if (e.target.closest('[data-open-picker]')) return;
          select(o.getAttribute('data-option'));
        });
        o.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(o.getAttribute('data-option')); }
        });
      });

      // Picker
      cfg.collections.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'TmpPicker__Chip' + (c.handle === state.collection ? ' is-active' : '');
        b.textContent = c.label;
        b.addEventListener('click', function () {
          chips.querySelectorAll('.TmpPicker__Chip').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          state.collection = c.handle;
          load(c.handle);
        });
        chips.appendChild(b);
      });

      function sized(url) { return url ? url.replace(/(\.\w+)(\?|$)/, '_160x160_crop_center$1$2') : ''; }

      function render(products) {
        if (!products || !products.length) { list.innerHTML = '<p class="TmpPicker__Empty">' + L.empty + '</p>'; return; }
        list.innerHTML = '';
        products.forEach(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return;
          var price = Math.round(parseFloat(v.price) * 100);
          var img = p.images && p.images[0] ? sized(p.images[0].src) : '';
          var item = document.createElement('button');
          item.type = 'button';
          item.className = 'TmpPicker__Item';
          // Black Month: reference (struck) price = 2.5× the selling price (−60%), shown discreetly next to each watch
          item.innerHTML = (img ? '<img src="' + img + '" alt="" loading="lazy" width="64" height="64">' : '<span></span>') +
            '<span class="TmpPicker__ItemName"></span><span class="TmpPicker__ItemPrices"><span class="TmpPicker__ItemPrice">' + formatMoney(price) + '</span><s class="TmpPicker__ItemCompare">' + formatMoney(Math.round(price * 2.5)) + '</s></span>';
          item.querySelector('.TmpPicker__ItemName').textContent = p.title;
          item.addEventListener('click', function () { pick({ id: v.id, price: price, title: p.title, img: img }); });
          list.appendChild(item);
        });
      }

      function load(handle) {
        if (state.cache[handle]) { render(state.cache[handle]); return; }
        list.innerHTML = '<p class="TmpPicker__Empty">' + L.loading + '</p>';
        fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250')
          .then(function (r) { return r.json(); })
          .then(function (d) { state.cache[handle] = d.products || []; if (state.collection === handle) render(state.cache[handle]); })
          .catch(function () { list.innerHTML = '<p class="TmpPicker__Empty">' + L.error + '</p>'; });
      }

      function openPicker(slot) {
        state.slot = slot;
        picker.querySelector('[data-picker-title]').textContent = slot === 2 ? L.pick2 : L.pick3;
        picker.hidden = false;
        document.documentElement.classList.add('tmp-lock');
        load(state.collection);
        var close = picker.querySelector('.TmpPicker__Close'); if (close) close.focus();
      }

      function closePicker() {
        picker.hidden = true;
        document.documentElement.classList.remove('tmp-lock');
        state.slot = null;
      }

      function pick(item) {
        var n = state.slot;
        state.slots[n] = item;
        var slotEl = el.querySelector('[data-slot="' + n + '"]');
        slotEl.classList.add('is-filled');
        var thumb = slotEl.querySelector('.TmpBundle__Thumb');
        thumb.classList.remove('TmpBundle__Thumb--empty');
        thumb.innerHTML = item.img ? '<img src="' + item.img + '" alt="" width="60" height="60">' : '';
        var lbl = slotEl.querySelector('.TmpBundle__SlotLabel');
        lbl.textContent = item.title;
        // discreet price + struck reference (2.5×) under the chosen watch
        var sp = document.createElement('span');
        sp.className = 'TmpBundle__SlotPrice';
        sp.innerHTML = '<span>' + formatMoney(item.price) + '</span> <s>' + formatMoney(Math.round(item.price * 2.5)) + '</s>';
        lbl.appendChild(sp);
        closePicker();
        select('bundle');
        updatePrices();
        updateButton();
      }

      el.querySelectorAll('[data-open-picker]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); openPicker(parseInt(b.getAttribute('data-open-picker'), 10)); });
      });
      picker.querySelectorAll('[data-close-picker]').forEach(function (b) { b.addEventListener('click', closePicker); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !picker.hidden) closePicker(); });

      // Variant changes from Prestige
      document.addEventListener('variant:changed', function (e) {
        var v = e.detail && e.detail.variant;
        if (!v) return;
        state.slots[1].id = v.id;
        state.slots[1].price = v.price;
        state.available = v.available;
        var s1now = el.querySelector('[data-slot-price-now]'), s1ref = el.querySelector('[data-slot-price-ref]');
        if (s1now) s1now.textContent = formatMoney(v.price);
        if (s1ref) s1ref.textContent = formatMoney(Math.round(v.price * 2.5));
        if (v.featured_image && v.featured_image.src) state.slots[1].img = sized(v.featured_image.src);
        updatePrices();
        updateButton();
      });

      submit.addEventListener('click', function () {
        if (state.option === 'bundle' && !(state.slots[2] && state.slots[3])) { openPicker(state.slots[2] ? 3 : 2); return; }
        var mainId = currentVariantId(el) || state.slots[1].id;
        msg.textContent = '';
        submit.disabled = true;
        submit.textContent = L.adding;
        if (state.option === 'single') {
          addItems([{ id: mainId, quantity: 1 }]).then(function () {
            updateButton();
            openCartDrawer(mainId);
          }).catch(function (err) {
            updateButton();
            msg.textContent = err.userFacing ? err.message : L.error;
          });
          return;
        }
        addItems([
          { id: mainId, quantity: 1 },
          { id: state.slots[2].id, quantity: 1 },
          { id: state.slots[3].id, quantity: 1 }
        ]).then(function () {
          var url = '/checkout';
          if (cfg.discountCode) url += '?discount=' + encodeURIComponent(cfg.discountCode);
          window.location.href = url;
        }).catch(function (err) {
          updateButton();
          msg.textContent = err.userFacing ? err.message : L.error;
        });
      });

      updatePrices();
      updateButton();
    });
  }

  /* --------------------------------------------------------------- MB WAY */
  function initMbway(root) {
    (root || document).querySelectorAll('[data-tempus-mbway]').forEach(function (btn) {
      if (btn._tmp) return;
      btn._tmp = true;
      btn.addEventListener('click', function () {
        var mainId = currentVariantId(btn);
        if (!mainId) return;
        btn.disabled = true;
        var handles = (btn.getAttribute('data-extras') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
        Promise.all(handles.map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (products) {
          var items = [{ id: mainId, quantity: 1 }];
          products.forEach(function (p) { if (p && p.variants && p.variants[0] && p.variants[0].available) items.push({ id: p.variants[0].id, quantity: 1 }); });
          return addItems(items).catch(function () { return addItems([{ id: mainId, quantity: 1 }]); });
        }).then(function () { window.location.href = '/checkout'; })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  /* ----------------------------------------------------------- sticky ATC */
  function initSticky() {
    var bar = document.querySelector('[data-tempus-sticky]');
    if (!bar) return;
    var target = document.querySelector('.TmpBundle, .ProductForm__BuyButtons');
    if (!target) return;
    bar.hidden = false;
    var past = false, drawerOpen = false;
    var render = function () {
      var on = past && !drawerOpen;
      bar.classList.toggle('is-visible', on);
      // lift floating launchers (FAQ / chat apps) above the bar so they never cover the CTA
      document.documentElement.style.setProperty('--tmp-sticky-h', bar.offsetHeight + 'px');
      document.body.classList.toggle('tmp-sticky-on', on);
    };
    // scroll-based (an IntersectionObserver misses jumps from below to above the target)
    var check = function () { past = target.getBoundingClientRect().bottom < 0; render(); };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
    // Hide while the cart drawer (or any Prestige drawer) is open, show again when it closes
    var drawers = document.querySelectorAll('#sidebar-cart, #sidebar-menu');
    var mo = new MutationObserver(function () {
      drawerOpen = Array.prototype.some.call(drawers, function (d) { return d.getAttribute('aria-hidden') === 'false'; });
      render();
    });
    drawers.forEach(function (d) { mo.observe(d, { attributes: true, attributeFilter: ['aria-hidden'] }); });
    // The sticky button always adds the watch itself (selected variant, qty 1) and opens the drawer,
    // whatever the state of the "Buy 3, Pay for 2" block (picker open or closed).
    var goBtn = bar.querySelector('[data-sticky-go]');
    goBtn.addEventListener('click', function () {
      if (goBtn.classList.contains('is-busy')) return;
      var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('[name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : NaN;
      if (!id) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      goBtn.classList.add('is-busy');
      addItems([{ id: id, quantity: 1 }]).then(function () {
        openCartDrawer(id);
      }).catch(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).then(function () {
        setTimeout(function () { goBtn.classList.remove('is-busy'); }, 800);
      });
    });
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      var pr = bar.querySelector('[data-sticky-price]'), cmp = bar.querySelector('[data-sticky-compare]');
      if (v && pr && cmp) { pr.textContent = formatMoney(v.price); cmp.textContent = formatMoney(Math.round(v.price * 2.5)); }
    });
  }


  /* ------------------------------------------- ATC limpo nos cards de produto */
  function initCardAtc() {
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('form[data-tmp-atc]') : null;
      if (!form) return;
      e.preventDefault();
      if (form._tmpBusy) return;
      var idEl = form.querySelector('[name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : NaN;
      if (!id) return;
      var btn = form.querySelector('.TmpAtc__Btn'), lbl = btn.querySelector('.TmpAtc__Label');
      var reset = function (ms) {
        setTimeout(function () {
          btn.classList.remove('is-added', 'is-error');
          lbl.textContent = form.getAttribute('data-l-add');
          form._tmpBusy = false;
        }, ms);
      };
      form._tmpBusy = true;
      btn.classList.add('is-loading');
      lbl.textContent = form.getAttribute('data-l-adding');
      addItems([{ id: id, quantity: 1 }]).then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        lbl.textContent = form.getAttribute('data-l-added');
        openCartDrawer(id);
        reset(2200);
      }).catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        lbl.textContent = form.getAttribute('data-l-error');
        reset(2200);
      });
    });
  }

  /* ---------------------------------------- código de desconto no cart drawer */
  function initCartDiscount() {
    var busy = false;
    var updateUrl = function () { return ((window.routes && window.routes.cartUrl) || '/cart') + '/update.js'; };
    var post = function (codes) {
      return fetch(updateUrl(), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); });
    };
    var setMsg = function (box, text, isError) {
      var m = box.querySelector('[data-tmp-disc-msg]');
      m.textContent = text || '';
      m.classList.toggle('is-error', !!(text && isError));
    };
    var run = function (box, codes, isRemove) {
      if (busy) return;
      busy = true;
      var apply = box.querySelector('[data-tmp-disc-apply]');
      apply.disabled = true; apply.textContent = box.getAttribute('data-l-applying');
      box.classList.add('is-busy');
      setMsg(box, '');
      var finish = function () {
        busy = false; box.classList.remove('is-busy');
        apply.disabled = false; apply.textContent = box.getAttribute('data-l-apply');
      };
      post(codes).then(function (cart) {
        var dc = (cart && cart.discount_codes) || [];
        var bad = dc.filter(function (d) { return !d.applicable; });
        if (bad.length && !isRemove) {
          // invalid code: put back only the valid ones, keep the field open with a subtle message
          var valid = dc.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
          return post(valid).then(function () { setMsg(box, box.getAttribute('data-l-invalid'), true); finish(); });
        }
        finish();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () { setMsg(box, box.getAttribute('data-l-error'), true); finish(); });
    };
    var currentCodes = function (box) {
      return (box.getAttribute('data-codes') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    };
    var submitInput = function (box) {
      var input = box.querySelector('[data-tmp-disc-input]');
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      var codes = currentCodes(box);
      if (!codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) codes.push(code);
      run(box, codes, false);
    };
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-tmp-disc-toggle],[data-tmp-disc-apply],[data-tmp-disc-remove]') : null;
      if (!t) return;
      var box = t.closest('[data-tmp-disc]');
      if (!box) return;
      if (t.hasAttribute('data-tmp-disc-toggle')) {
        var row = box.querySelector('[data-tmp-disc-row]'), open = row.hidden;
        row.hidden = !open;
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        box.classList.toggle('is-open', open);
        if (open) box.querySelector('[data-tmp-disc-input]').focus();
        return;
      }
      if (t.hasAttribute('data-tmp-disc-apply')) { submitInput(box); return; }
      var rm = (t.getAttribute('data-tmp-disc-remove') || '').toLowerCase();
      run(box, currentCodes(box).filter(function (c) { return c.toLowerCase() !== rm; }), true);
    });
    // Enter inside the field must NOT submit the cart form (that would go to checkout)
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-tmp-disc-input]')) return;
      e.preventDefault();
      submitInput(e.target.closest('[data-tmp-disc]'));
    });
  }

  /* -------------------------------------------- landing offer (TempusOffer) */
  function initOffers(root) {
    (root || document).querySelectorAll('[data-tempus-offer]').forEach(function (el) {
      var cfgEl = el.querySelector('[data-offer-config]');
      if (!cfgEl || el._tmpOffer) return;
      el._tmpOffer = true;
      var cfg = JSON.parse(cfgEl.textContent);
      var products = cfg.products.filter(function (p) { return p.available; });
      var slots = Array.prototype.slice.call(el.querySelectorAll('[data-offer-slot]'));
      var chosen = {};
      var current = null;
      var picker = el.querySelector('[data-offer-picker]');
      var list = picker.querySelector('[data-picker-list]');
      var submit = el.querySelector('[data-offer-submit]');
      var msg = el.querySelector('[data-offer-msg]');
      document.body.appendChild(picker);

      function close() { picker.hidden = true; document.documentElement.classList.remove('tmp-lock'); }
      function open(slot) {
        current = slot;
        var priority = (slot.getAttribute('data-priority') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
        var sorted = products.slice().sort(function (a, b) {
          var ia = priority.indexOf(a.handle), ib = priority.indexOf(b.handle);
          return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
        });
        var free = slot.getAttribute('data-free') === 'true';
        picker.querySelector('[data-picker-title]').textContent = slot.querySelector('[data-slot-title]').getAttribute('data-label') || slot.querySelector('[data-slot-title]').textContent;
        list.innerHTML = '';
        sorted.forEach(function (p) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'TmpPicker__Item';
          b.innerHTML = '<img src="' + p.img + '" alt="" width="64" height="64" loading="lazy"><span class="TmpPicker__ItemName"></span><span class="TmpPicker__ItemPrice">' +
            (free ? '<s>' + formatMoney(p.price) + '</s> Free' : formatMoney(p.price)) + '</span>';
          b.querySelector('.TmpPicker__ItemName').textContent = p.title;
          b.addEventListener('click', function () { pick(p); });
          list.appendChild(b);
        });
        picker.hidden = false;
        document.documentElement.classList.add('tmp-lock');
      }
      function pick(p) {
        var n = current.getAttribute('data-offer-slot');
        chosen[n] = p;
        var title = current.querySelector('[data-slot-title]');
        if (!title.getAttribute('data-label')) title.setAttribute('data-label', title.textContent);
        title.textContent = p.title;
        current.querySelector('[data-slot-price]').textContent = current.getAttribute('data-free') === 'true' ? 'Free' : formatMoney(p.price);
        var thumb = current.querySelector('.TmpOffer__Thumb');
        thumb.classList.remove('TmpOffer__Thumb--empty');
        thumb.innerHTML = '<img src="' + p.img + '" alt="" width="56" height="56">';
        current.classList.add('is-filled');
        close();
        update();
      }
      function update() {
        var ready = slots.every(function (s) { return chosen[s.getAttribute('data-offer-slot')]; });
        var ref = 0, pay = 0;
        slots.forEach(function (s) {
          var p = chosen[s.getAttribute('data-offer-slot')];
          if (!p) return;
          ref += Math.round(p.price * 2.5);
          if (s.getAttribute('data-free') !== 'true') pay += p.price;
        });
        var sum = el.querySelector('[data-offer-sum]');
        sum.hidden = !ready;
        if (ready) {
          el.querySelector('[data-offer-ref]').textContent = formatMoney(ref);
          el.querySelector('[data-offer-pay]').textContent = formatMoney(pay);
          el.querySelector('[data-offer-save]').textContent = 'You save ' + formatMoney(ref - pay);
          submit.textContent = cfg.readyLabel;
        }
        submit.disabled = !ready;
      }
      slots.forEach(function (s) { s.addEventListener('click', function () { open(s); }); });
      // The offer artwork (e.g. live "CTA 1" banner) opens the first empty slot, as on the live lander
      var openFirst = function () {
        if (slots.every(function (x) { return chosen[x.getAttribute('data-offer-slot')]; })) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        var s = slots.filter(function (x) { return !chosen[x.getAttribute('data-offer-slot')]; })[0] || slots[0]; open(s);
      };
      var art = el.querySelector('[data-offer-open]');
      if (art) {
        art.addEventListener('click', openFirst);
        art.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openFirst(); } });
      }
      // External triggers (price card, final CTA) open this offer's picker by anchor id
      window.TempusOffers = window.TempusOffers || {};
      window.TempusOffers[el.getAttribute('data-offer-id') || el.id] = openFirst;
      picker.querySelectorAll('[data-close-picker]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !picker.hidden) close(); });
      submit.addEventListener('click', function () {
        var items = slots.map(function (s) { return { id: chosen[s.getAttribute('data-offer-slot')].id, quantity: 1 }; });
        submit.disabled = true;
        msg.textContent = '';
        addItems(items).then(function () {
          var url = '/checkout';
          var q = [];
          if (cfg.discount) q.push('discount=' + encodeURIComponent(cfg.discount));
          if (cfg.skipShopPay) q.push('skip_shop_pay=true');
          window.location.href = url + (q.length ? '?' + q.join('&') : '');
        }).catch(function (err) {
          submit.disabled = false;
          msg.textContent = err.userFacing ? err.message : 'Could not add. Please try again.';
        });
      });
    });
  }

  /* ---------------------------------------------------------- sliders */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-tmp-slider]').forEach(function (s) {
      if (s._tmp) return;
      s._tmp = true;
      var track = s.querySelector('[data-tmp-slider-track]');
      var step = function (dir) {
        var cell = track.firstElementChild;
        var w = cell ? cell.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
        track.scrollBy({ left: dir * w * Math.max(1, Math.floor(track.clientWidth / w)), behavior: 'smooth' });
      };
      var sync = function () {
        s.classList.toggle('is-start', track.scrollLeft < 8);
        s.classList.toggle('is-end', track.scrollLeft + track.clientWidth > track.scrollWidth - 8);
      };
      s.querySelector('[data-tmp-slider-prev]').addEventListener('click', function () { step(-1); });
      s.querySelector('[data-tmp-slider-next]').addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  }

  /* ------------------------------------------------- PDP 2.5× reference price (Black Month −60%) */
  function initPriceRule() {
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      setTimeout(function () {
        document.querySelectorAll('[data-tempus-price]').forEach(function (list) {
          list.innerHTML = '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4">' + formatMoney(v.price) + '</span>' +
            '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4">' + formatMoney(Math.round(v.price * 2.5)) + '</span>' +
            '<span class="TmpShipNote">+ Free shipping</span>';
        });
      }, 0);
    });
  }

  /* ------------------------------------------------- cinema films (lazy) */
  // Video src is only attached when the film is near the viewport; autoplay muted inline,
  // pause off-screen / hidden tab; no autoplay with reduced motion or Save-Data (tap to play).
  var filmIO = null;
  function initFilms(root) {
    var frames = (root || document).querySelectorAll('[data-tmp-film]');
    if (!frames.length) return;
    var conn = navigator.connection || {};
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches || conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');
    var load = function (f) {
      var v = f._v;
      if (!v || v.getAttribute('src')) return;
      v.src = v.getAttribute('data-src');
      v.preload = 'auto';
    };
    var play = function (f) {
      if (!f._v) return;
      load(f);
      var p = f._v.play(); if (p && p.catch) p.catch(function () { f.classList.remove('is-auto'); });
    };
    if (!filmIO && 'IntersectionObserver' in window) {
      filmIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var f = e.target;
          f._visible = e.isIntersecting && e.intersectionRatio >= 0.35;
          if (f._visible && (f._auto || f._user)) play(f);
          else if (!f._visible && f._v && !f._v.paused) f._v.pause();
        });
      }, { threshold: [0, 0.35, 0.6] });
      document.addEventListener('visibilitychange', function () {
        document.querySelectorAll('[data-tmp-film]').forEach(function (f) {
          if (!f._v) return;
          if (document.hidden) f._v.pause(); else if (f._visible && (f._auto || f._user)) play(f);
        });
      });
    }
    frames.forEach(function (f) {
      if (f._tmpFilm) return;
      f._tmpFilm = true;
      f._v = f.querySelector('video');
      f._auto = !calm && !!f._v;
      if (f._auto) f.classList.add('is-auto');
      if (!f._v) return;
      f._v.addEventListener('playing', function () { f.classList.add('is-playing'); });
      f._v.addEventListener('timeupdate', function () {
        var d = f._v.duration; if (d) f.style.setProperty('--p', (f._v.currentTime / d).toFixed(3));
      });
      var playBtn = f.querySelector('[data-film-play]');
      if (playBtn) playBtn.addEventListener('click', function () { f._user = true; f.classList.add('is-auto'); play(f); });
      var sound = f.querySelector('[data-film-sound]');
      if (sound) sound.addEventListener('click', function () {
        var on = f._v.muted;
        document.querySelectorAll('[data-tmp-film] video').forEach(function (o) { o.muted = true; });
        document.querySelectorAll('[data-film-sound]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Turn sound on'); });
        f._v.muted = !on;
        sound.setAttribute('aria-pressed', on ? 'true' : 'false');
        sound.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
        if (on) { f._user = true; f._v.currentTime = 0; play(f); }
      });
      if (filmIO) filmIO.observe(f);
      else if (f._auto) play(f);
    });
    // CTA inside a film section that jumps to the buy box on product pages
    (root || document).querySelectorAll('[data-tmp-scroll-buy]').forEach(function (a) {
      if (a._tmp) return;
      a._tmp = true;
      a.addEventListener('click', function (e) {
        var t = document.querySelector('.TmpBundle, .ProductForm__BuyButtons, .ProductForm');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ------------------------------------------- watch-case detection (canvas) */
  // Finds the case of a front-facing watch photo on a plain/transparent background:
  // background = corner colour; for each row the left/right extent of the watch; the case is the
  // widest band; its centre row gives cy, its left edge + radius gives cx (the crown is ignored).
  // Returns fractions { x, y (of width/height), r (of width), ar } or null if the photo is not usable.
  var detectCache = {};
  function detectWatch(src, cb) {
    if (!src) { cb(null); return; }
    if (detectCache[src] !== undefined) { cb(detectCache[src]); return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var res = null;
      try {
        var w = 200, h = Math.max(1, Math.round(w * im.naturalHeight / im.naturalWidth));
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var cx2 = cv.getContext('2d', { willReadFrequently: true });
        cx2.drawImage(im, 0, 0, w, h);
        var d = cx2.getImageData(0, 0, w, h).data;
        var px = function (x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; };
        var bg = [0, 0, 0, 0], n = 0;
        [[0, 0], [w - 4, 0], [0, h - 4], [w - 4, h - 4]].forEach(function (c) {
          for (var yy = 0; yy < 4; yy++) for (var xx = 0; xx < 4; xx++) { var q = px(c[0] + xx, c[1] + yy); bg[0] += q[0]; bg[1] += q[1]; bg[2] += q[2]; bg[3] += q[3]; n++; }
        });
        bg = bg.map(function (v) { return v / n; });
        var transparentBg = bg[3] < 128;
        var fg = function (x, y) {
          var q = px(x, y);
          if (q[3] < 40) return false;
          if (transparentBg) return true;
          var dr = q[0] - bg[0], dg = q[1] - bg[1], db = q[2] - bg[2];
          return dr * dr + dg * dg + db * db > 38 * 38;
        };
        var L = [], R = [], maxW = 0;
        for (var y = 0; y < h; y++) {
          var l = -1, r = -1, cnt = 0;
          for (var x = 0; x < w; x++) if (fg(x, y)) { if (l < 0) l = x; r = x; cnt++; }
          L.push(l); R.push(r);
          var ww = r - l;
          if (l >= 0 && cnt > ww * 0.5 && ww > maxW) maxW = ww;
        }
        if (maxW < w * 0.2) throw 0;
        // longest run of rows at >= 80% of the max width (gaps of 2 rows allowed)
        var best = [0, -1], start = -1, gap = 0;
        for (var y2 = 0; y2 <= h; y2++) {
          var wide = y2 < h && L[y2] >= 0 && (R[y2] - L[y2]) >= maxW * 0.8;
          if (wide) { if (start < 0) start = y2; gap = 0; }
          else if (start >= 0 && ++gap > 2) { var end = y2 - gap; if (end - start > best[1] - best[0]) best = [start, end]; start = -1; gap = 0; }
        }
        if (best[1] - best[0] < h * 0.06) throw 0;
        var cyp = (best[0] + best[1]) / 2;
        var band = [], k0 = Math.max(best[0], Math.round(cyp - (best[1] - best[0]) * 0.2)), k1 = Math.min(best[1], Math.round(cyp + (best[1] - best[0]) * 0.2));
        for (var k = k0; k <= k1; k++) band.push([L[k], R[k]]);
        band.sort(function (a, b) { return a[0] - b[0]; });
        var medL = band[Math.floor(band.length / 2)][0];
        var span = band.map(function (b) { return b[1] - b[0]; }).sort(function (a, b) { return a - b; })[Math.floor(band.length / 2)];
        var rad = span / 2 / 1.06;                     // the crown adds ~6% on the right
        var cxp = medL + rad;
        if (rad < w * 0.1 || rad > w * 0.5 || cyp < h * 0.15 || cyp > h * 0.85) throw 0;
        res = { x: cxp / w, y: cyp / h, r: rad / w, ar: w / h };
      } catch (e) { res = null; }
      detectCache[src] = res; cb(res);
    };
    im.onerror = function () { detectCache[src] = null; cb(null); };
    im.src = src;
  }

  /* ------------------------------------------------------ anatomy (hotspots) */
  // All hotspots are visible at once. Hover (desktop) previews a detail card anchored to the point,
  // click/tap/Enter pins it; click outside or Esc closes. Cards are kept inside the image frame.
  function initAnatomy(root) {
    (root || document).querySelectorAll('[data-tmp-anatomy]').forEach(function (sec) {
      if (sec._tmp) return;
      sec._tmp = true;
      var specs = sec.querySelector('[data-anat-specs]');
      if (specs && window.matchMedia('(min-width: 900px)').matches) specs.open = true;
      var media = sec.querySelector('[data-anat-media]');
      if (!media) return;
      var box = media.querySelector('.TmpAnat__Box');
      var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var openN = 0, pinned = false;

      // anchored hotspots (detected case)
      var mainImg = box.querySelector(':scope > img');
      sec.querySelectorAll('.TmpAnat__Spot[data-anchor]').forEach(function (spot) {
        var a = spot.getAttribute('data-anchor');
        if (!mainImg) return;
        detectWatch(mainImg.currentSrc || mainImg.src, function (m) {
          if (!m) return;
          var ry = m.r * m.ar, x = m.x, y = m.y;
          if (a === 'bezel') y = m.y - ry * 0.86;
          else if (a === 'crown') x = m.x + m.r * 1.04;
          else if (a === 'bracelet') y = Math.min(0.94, m.y + ry * 1.75);
          spot.style.left = (x * 100).toFixed(2) + '%';
          spot.style.top = (Math.max(0.05, y) * 100).toFixed(2) + '%';
          if (openN) place(openN);
        });
      });

      var spotOf = function (n) { return sec.querySelector('[data-spot="' + n + '"]'); };
      var cardOf = function (n) { return sec.querySelector('[data-card="' + n + '"]'); };
      var place = function (n) {
        var card = cardOf(n), spot = spotOf(n);
        if (!card || !spot) return;
        var m = media.getBoundingClientRect(), b = box.getBoundingClientRect(), s = spot.getBoundingClientRect();
        var pad = 8, w = Math.min(280, m.width - pad * 2);
        card.style.width = w + 'px';
        var h = card.offsetHeight;
        var sx = s.left + s.width / 2, sy = s.top + s.height / 2;
        var side = sx + 24 + w <= m.right - pad ? 'r' : (sx - 24 - w >= m.left + pad ? 'l' : 'v');
        var left = side === 'r' ? sx + 24 : side === 'l' ? sx - 24 - w : sx - w / 2;
        left = Math.max(m.left + pad, Math.min(left, m.right - pad - w));
        var top = sy - h / 2;
        if (side === 'v') top = sy + 22 + h <= m.bottom - pad ? sy + 22 : sy - 22 - h; // no room beside: below (or above) the point
        top = Math.max(m.top + pad, Math.min(top, m.bottom - pad - h));
        card.style.left = (left - b.left) + 'px';
        card.style.top = (top - b.top) + 'px';
      };
      var close = function (focusBack) {
        if (!openN) return;
        var n = openN;
        cardOf(n).hidden = true;
        spotOf(n).setAttribute('aria-expanded', 'false');
        sec.querySelectorAll('.is-open').forEach(function (e) { e.classList.remove('is-open'); });
        openN = 0; pinned = false;
        if (focusBack) spotOf(n).focus();
      };
      var open = function (n, pin) {
        if (openN && openN !== n) close();
        var card = cardOf(n);
        card.hidden = false;
        spotOf(n).setAttribute('aria-expanded', 'true');
        spotOf(n).classList.add('is-open');
        var item = sec.querySelector('[data-item="' + n + '"]'); if (item) item.classList.add('is-open');
        openN = n; pinned = !!pin;
        place(n);
      };
      sec.querySelectorAll('[data-spot]').forEach(function (spot) {
        var n = +spot.getAttribute('data-spot');
        spot.addEventListener('click', function (e) {
          e.stopPropagation();
          if (openN === n && pinned) close(); else open(n, true);
        });
        if (hoverable) {
          spot.addEventListener('mouseenter', function () { if (!pinned) open(n, false); });
          spot.addEventListener('mouseleave', function () { if (!pinned && openN === n) close(); });
        }
      });
      sec.querySelectorAll('[data-open]').forEach(function (btn) {
        var n = +btn.getAttribute('data-open');
        btn.addEventListener('click', function (e) { e.stopPropagation(); open(n, true); });
        if (hoverable) {
          btn.addEventListener('mouseenter', function () { if (!pinned) open(n, false); });
          btn.addEventListener('mouseleave', function () { if (!pinned && openN === n) close(); });
        }
      });
      sec.querySelectorAll('[data-card]').forEach(function (card) { card.addEventListener('click', function (e) { e.stopPropagation(); }); });
      sec.querySelectorAll('[data-card-close]').forEach(function (b) { b.addEventListener('click', function () { close(true); }); });
      document.addEventListener('click', function () { if (openN) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openN) close(true); });
      window.addEventListener('resize', function () { if (openN) place(openN); });
    });
  }

  /* ----------------------------------------------------- wrist simulator */
  // Real scale: 1 SVG unit = 1 mm. Top view, forearm horizontal (hand on the right), watch upright.
  function initWrist(root) {
    (root || document).querySelectorAll('[data-tmp-wrist]').forEach(function (sec) {
      if (sec._tmp) return;
      sec._tmp = true;
      var svg = sec.querySelector('[data-wrist-svg]');
      var range = sec.querySelector('[data-wrist-range]');
      var out = sec.querySelector('[data-wrist-value]');
      var widthOut = sec.querySelector('[data-wrist-width]');
      var readout = sec.querySelector('[data-wrist-readout]');
      var desc = sec.querySelector('[data-wrist-desc]');
      var num = function (k, d) { var v = parseFloat(sec.getAttribute(k)); return isNaN(v) ? d : v; };
      var D = num('data-diameter', 40), LUG = num('data-lug', 20), L2L = num('data-l2l', 0) || D * 1.2;
      var MIN = num('data-min', 0), MAX = num('data-max', 99);
      var img = sec.getAttribute('data-image');
      var uid = 'tw' + Math.random().toString(36).slice(2, 7);
      var fmt = function (n) { return n.toFixed(1); };
      var VW = 160, VH = 104, cx = 82, cy = VH / 2;
      var draw = function () {
        var c = parseFloat(range.value);
        var W = c * 10 / Math.PI * 0.95;           // visible wrist width (top view, wrist bone) in mm
        var hw = W / 2, fw = W * 1.28 / 2, pw = W * 1.5 / 2;  // forearm (left) and palm (right) half-widths
        // forearm narrowing to the wrist, then the base of the hand widening (palm edge + thumb side)
        var arm = 'M-90,' + (cy - fw) + ' L-10,' + (cy - fw) + ' C30,' + (cy - fw) + ' 60,' + (cy - hw) + ' ' + cx + ',' + (cy - hw) +
          ' C' + (cx + 18) + ',' + (cy - hw) + ' ' + (cx + 30) + ',' + (cy - hw * 1.08) + ' ' + (cx + 44) + ',' + (cy - pw) + ' L' + (VW + 90) + ',' + (cy - pw) +
          ' L' + (VW + 90) + ',' + (cy + pw) + ' L' + (cx + 44) + ',' + (cy + pw) + ' C' + (cx + 30) + ',' + (cy + hw * 1.08) + ' ' + (cx + 18) + ',' + (cy + hw) + ' ' + cx + ',' + (cy + hw) +
          ' C60,' + (cy + hw) + ' 30,' + (cy + fw) + ' -10,' + (cy + fw) + ' L-90,' + (cy + fw) + ' Z';
        var r = D / 2;
        var caseShape = sec.getAttribute('data-shape') || 'round';
        var shape = function (rr, attrs) { // case outline for the given half-size
          if (caseShape === 'octagon') { var pts = []; for (var k = 0; k < 8; k++) { var ang = Math.PI / 8 + k * Math.PI / 4; pts.push((cx + rr * Math.cos(ang)).toFixed(2) + ',' + (cy + rr * Math.sin(ang)).toFixed(2)); } return '<polygon points="' + pts.join(' ') + '"' + attrs + '/>'; }
          if (caseShape === 'square') { var sq = rr * 0.96; return '<rect x="' + (cx - sq) + '" y="' + (cy - sq) + '" width="' + sq * 2 + '" height="' + sq * 2 + '" rx="' + (rr * 0.18) + '"' + attrs + '/>'; }
          if (caseShape === 'cushion') { var cu = rr * 0.97; return '<rect x="' + (cx - cu) + '" y="' + (cy - cu) + '" width="' + cu * 2 + '" height="' + cu * 2 + '" rx="' + (rr * 0.42) + '"' + attrs + '/>'; }
          return '<circle cx="' + cx + '" cy="' + cy + '" r="' + rr + '"' + attrs + '/>';
        };
        var vw = Math.max(130, D * 2.6), vh = vw * VH / VW;
        svg.setAttribute('viewBox', (cx - vw / 2).toFixed(1) + ' ' + (cy - vh / 2).toFixed(1) + ' ' + vw.toFixed(1) + ' ' + vh.toFixed(1));
        // no usable product photo (lifestyle shot, failed detection): neutral dial instead of a wrong crop
        var genericDial = function () {
          var g = '<circle cx="' + cx + '" cy="' + cy + '" r="' + (r * 0.92) + '" fill="#2a2a2a"/><circle cx="' + cx + '" cy="' + cy + '" r="' + (r * 0.78) + '" fill="#1b1b1b"/>';
          for (var i = 0; i < 12; i++) {
            var a = i * Math.PI / 6, r1 = r * 0.7, r2 = r * (i % 3 ? 0.62 : 0.56);
            g += '<line x1="' + (cx + r1 * Math.sin(a)) + '" y1="' + (cy - r1 * Math.cos(a)) + '" x2="' + (cx + r2 * Math.sin(a)) + '" y2="' + (cy - r2 * Math.cos(a)) + '" stroke="#e8e2d8" stroke-width="' + (i % 3 ? 0.6 : 1.1) + '" stroke-linecap="round"/>';
          }
          return g + '<line x1="' + cx + '" y1="' + cy + '" x2="' + (cx + r * 0.32) + '" y2="' + (cy - r * 0.22) + '" stroke="#e8e2d8" stroke-width="1" stroke-linecap="round"/><line x1="' + cx + '" y1="' + cy + '" x2="' + (cx - r * 0.12) + '" y2="' + (cy - r * 0.52) + '" stroke="#e8e2d8" stroke-width=".7" stroke-linecap="round"/><circle cx="' + cx + '" cy="' + cy + '" r=".9" fill="#e8e2d8"/>';
        };
        var lugs = function () { // four lugs, 2.4 mm wide, from inside the case to lug-to-lug / 2
          var lw = 2.4, xs = [cx - LUG / 2 - lw, cx + LUG / 2], g = '';
          xs.forEach(function (x) {
            var inner = Math.sqrt(Math.max(0, r * r - Math.pow(Math.max(Math.abs(x - cx), Math.abs(x + lw - cx)), 2))) - 1.5;
            var len = L2L / 2 - inner;
            g += '<rect x="' + x + '" y="' + (cy - L2L / 2) + '" width="' + lw + '" height="' + len + '" rx="1" fill="url(#' + uid + 'c)" stroke="#8d8d8d" stroke-width=".25"/>';
            g += '<rect x="' + x + '" y="' + (cy + inner) + '" width="' + lw + '" height="' + len + '" rx="1" fill="url(#' + uid + 'c)" stroke="#8d8d8d" stroke-width=".25"/>';
          });
          return g;
        };
        svg.innerHTML =
          '<defs>' +
          '<linearGradient id="' + uid + 'a" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#cdb79f"/><stop offset=".22" stop-color="#e6d3bf"/><stop offset=".5" stop-color="#efdfcd"/><stop offset=".8" stop-color="#e2cdb6"/><stop offset="1" stop-color="#c8b198"/></linearGradient>' +
          '<linearGradient id="' + uid + 's" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#1f1f1f"/><stop offset=".25" stop-color="#4a4a4a"/><stop offset=".75" stop-color="#4a4a4a"/><stop offset="1" stop-color="#1f1f1f"/></linearGradient>' +
          '<radialGradient id="' + uid + 'c" cx=".4" cy=".35" r=".8"><stop offset="0" stop-color="#f2f2f2"/><stop offset="1" stop-color="#9c9c9c"/></radialGradient>' +
          '<filter id="' + uid + 'f" x="-40%" y="-40%" width="180%" height="180%"><feGaussianBlur stdDeviation="2.2"/></filter>' +
          '<clipPath id="' + uid + 'm">' + shape(r * (det ? 0.97 : 0.9), '') + '</clipPath>' +
          '<clipPath id="' + uid + 'k"><path d="' + arm + '"/></clipPath>' +
          '</defs>' +
          '<path d="' + arm + '" fill="url(#' + uid + 'a)"/>' +
          '<path d="' + arm + '" fill="none" stroke="rgba(120,90,60,.22)" stroke-width=".6"/>' +
          '<path d="M' + (cx + 30) + ',' + (cy - hw * 0.55) + ' Q' + (cx + 34) + ',' + cy + ' ' + (cx + 30) + ',' + (cy + hw * 0.55) + '" fill="none" stroke="rgba(120,90,60,.18)" stroke-width=".5"/>' +
          '<ellipse cx="' + (cx + 1.5) + '" cy="' + (cy + 2.5) + '" rx="' + (r + 3) + '" ry="' + (L2L / 2 + 1) + '" fill="rgba(60,40,25,.28)" filter="url(#' + uid + 'f)"/>' +
          '<rect clip-path="url(#' + uid + 'k)" x="' + (cx - LUG / 2) + '" y="-60" width="' + LUG + '" height="' + (VH + 120) + '" fill="url(#' + uid + 's)"/>' +
          lugs() +
          '<rect x="' + (cx + r - 1) + '" y="' + (cy - 2.6) + '" width="4" height="5.2" rx="1" fill="#b9b9b9" stroke="#8d8d8d" stroke-width=".3"/>' +
          shape(r, ' fill="url(#' + uid + 'c)" stroke="#8d8d8d" stroke-width=".35"') +
          (img && det ? '<image href="' + img + '" x="' + (cx - det.x * (r / det.r)) + '" y="' + (cy - det.y * (r / det.r) / det.ar) + '" width="' + (r / det.r) + '" height="' + (r / det.r / det.ar) + '" preserveAspectRatio="none" clip-path="url(#' + uid + 'm)"/>'
           : genericDial()) +
          (det ? '' : shape(r * 0.9, ' fill="none" stroke="rgba(0,0,0,.25)" stroke-width=".4"')) +
          // corner label with the case size (the measures list has the rest)
          '<text x="' + (cx - vw / 2 + 3) + '" y="' + (cy - vh / 2 + 5) + '" font-size="3.2" fill="#8b1a1a" letter-spacing=".3">Ø ' + fmt(D).replace(',0', '') + ' mm</text>';
        out.textContent = fmt(c) + ' cm';
        widthOut.textContent = '≈ ' + Math.round(W) + ' mm';
        var pct = Math.round(D / W * 100);
        var msg = 'On a ' + fmt(c) + ' cm wrist (≈ ' + Math.round(W) + ' mm wide), the ' + fmt(D).replace(',0', '').replace('.0', '') + ' mm case covers about ' + pct + '% of the wrist width.';
        if (c < MIN || c > MAX) msg += ' This is outside the bracelet adjustment range (' + fmt(MIN) + '–' + fmt(MAX) + ' cm): contact us before ordering.';
        readout.textContent = msg;
        if (desc) desc.textContent = 'Scale simulation: ' + D + ' mm watch on a wrist of ' + fmt(c) + ' cm.';
      };
      var det = null;
      range.addEventListener('input', draw);
      draw();
      detectWatch(img, function (m) { det = m; sec.setAttribute('data-dial', m ? 'detected' : 'fallback'); draw(); });
    });
  }

  /* ---------------------------------------------- case builder (collection) */
  function initCase(root) {
    var el = (root || document).querySelector('[data-tmp-case]');
    if (!el || el._tmp) return;
    el._tmp = true;
    var KEY = 'tmpCase';
    var items = [];
    try { items = JSON.parse(sessionStorage.getItem(KEY) || '[]') || []; } catch (e) { items = []; }
    var bar = el.querySelector('[data-case-bar]');
    var spacer = el.querySelector('[data-case-spacer]');
    var cta = el.querySelector('[data-case-cta]');
    var status = el.querySelector('[data-case-status]');
    var sum = el.querySelector('[data-case-sum]');
    var progress = el.querySelector('[data-case-progress]');
    var baseText = status.textContent;
    var emptyCta = cta.textContent;
    var docked = false;
    var save = function () { try { sessionStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} };
    var dock = function () {
      var should = items.length > 0 && spacer.getBoundingClientRect().top < -bar.offsetHeight;
      if (should !== docked) {
        docked = should;
        spacer.style.height = should ? bar.offsetHeight + 'px' : '';
        el.classList.toggle('is-docked', should);
        document.documentElement.style.setProperty('--tmp-case-h', bar.offsetHeight + 'px');
        document.body.classList.toggle('tmp-case-docked', should);
      }
    };
    var render = function () {
      el.querySelectorAll('[data-case-slot]').forEach(function (slot) {
        var i = +slot.getAttribute('data-case-slot') - 1;
        var it = items[i];
        var btn = slot.querySelector('[data-case-remove]');
        var thumb = slot.querySelector('.TmpCase__Thumb');
        slot.classList.toggle('is-filled', !!it);
        btn.disabled = !it;
        btn.setAttribute('aria-label', it ? 'Remove ' + it.title : 'Slot ' + (i + 1) + ' empty');
        thumb.innerHTML = it ? '<img src="' + it.img + '" alt="" width="56" height="56">' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>';
      });
      progress.style.width = (items.length / 3 * 100) + '%';
      if (items.length === 3) {
        var prices = items.map(function (x) { return x.price; }).sort(function (a, b) { return a - b; });
        var total = prices[0] + prices[1] + prices[2];
        sum.hidden = false;
        sum.innerHTML = '<s>' + formatMoney(Math.round(total * 2.5)) + '</s> <strong>' + formatMoney(total - prices[0]) + '</strong>';
        status.textContent = 'Box complete: the cheapest one is free.';
        cta.textContent = el.getAttribute('data-cta');
      } else {
        var left = 3 - items.length;
        sum.hidden = true;
        status.textContent = items.length ? 'Add' + (left === 1 ? ' 1 more watch' : ' ' + left + ' more watches') + ' — the cheapest one is free.' : baseText;
        cta.textContent = emptyCta;
      }
      el.classList.toggle('has-items', items.length > 0);
      dock();
    };
    window.addEventListener('scroll', dock, { passive: true });
    el.querySelectorAll('[data-case-remove]').forEach(function (b) {
      b.addEventListener('click', function () { items.splice(+b.getAttribute('data-case-remove') - 1, 1); save(); render(); });
    });
    cta.addEventListener('click', function () {
      if (items.length < 3) {
        var grid = document.querySelector('.CollectionInner__Products, .ProductListWrapper');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      cta.disabled = true;
      addItems(items.map(function (x) { return { id: x.id, quantity: 1 }; })).then(function () {
        try { sessionStorage.removeItem(KEY); } catch (e) {}
        var code = el.getAttribute('data-discount');
        window.location.href = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : '');
      }).catch(function (err) { cta.disabled = false; status.textContent = err.userFacing ? err.message : 'Could not add. Please try again.'; });
    });
    var label = el.getAttribute('data-add-label');
    document.querySelectorAll('.CollectionInner .ProductItem, .ProductListWrapper .ProductItem').forEach(function (card) {
      if (card._tmpCase) return;
      var link = card.querySelector('a[href*="/products/"]');
      var wrap = card.querySelector('.ProductItem__Wrapper');
      if (!link || !wrap) return;
      card._tmpCase = true;
      var handle = link.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'TmpCaseAdd';
      b.setAttribute('aria-label', label + ': ' + (card.querySelector('.ProductItem__Title') || link).textContent.trim());
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.6" fill="none"/></svg><span>' + label + '</span>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (items.length >= 3) { status.textContent = 'Your box already has 3 watches. Remove one to swap.'; return; }
        b.classList.add('is-busy');
        fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }).then(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          b.classList.remove('is-busy');
          if (!v) { status.textContent = 'That watch is sold out.'; return; }
          var src = (v.featured_image && v.featured_image.src) || p.featured_image || '';
          if (src.indexOf('//') === 0) src = 'https:' + src;
          items.push({ id: v.id, price: v.price, title: p.title, img: src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '' });
          save(); render();
          b.classList.add('is-added'); setTimeout(function () { b.classList.remove('is-added'); }, 1200);
        }).catch(function () { b.classList.remove('is-busy'); });
      });
      wrap.appendChild(b);
    });
    render();
  }

  /* -------------------------------------------------------- review wall */
  function initWall(root) {
    (root || document).querySelectorAll('[data-tmp-wall]').forEach(function (sec) {
      if (sec._tmp) return;
      sec._tmp = true;
      var limit = +sec.getAttribute('data-limit') || 8;
      var cards = Array.prototype.slice.call(sec.querySelectorAll('.TmpWall__Card'));
      var more = sec.querySelector('[data-wall-more]');
      var filter = '', expanded = false;
      var apply = function () {
        var shown = 0;
        cards.forEach(function (c) {
          var match = !filter || c.getAttribute('data-model') === filter;
          c.hidden = !(match && (expanded || shown < limit));
          if (match) shown++;
        });
        more.hidden = expanded || shown <= limit;
      };
      sec.querySelectorAll('[data-wall-filter]').forEach(function (b) {
        b.addEventListener('click', function () {
          sec.querySelectorAll('[data-wall-filter]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          filter = b.getAttribute('data-wall-filter');
          apply();
        });
      });
      more.addEventListener('click', function () { expanded = true; apply(); });
      var box = sec.querySelector('[data-wall-box]');
      document.body.appendChild(box);
      var close = function () { box.hidden = true; document.documentElement.classList.remove('tmp-lock'); };
      sec.querySelectorAll('[data-wall-open]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = b.closest('.TmpWall__Card');
          var im = box.querySelector('[data-wall-img]');
          im.src = b.getAttribute('data-full');
          im.alt = b.getAttribute('aria-label');
          box.querySelector('[data-wall-caption]').textContent = '“' + card.querySelector('.TmpReview__Text').textContent + '” — ' + card.querySelector('.TmpReview__Name').textContent;
          box.hidden = false;
          document.documentElement.classList.add('tmp-lock');
          box.querySelector('[data-wall-close]').focus();
        });
      });
      box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('[data-wall-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
      apply();
    });
  }

  /* --------------------------------------------------------------- quiz */
  function initQuiz(root) {
    (root || document).querySelectorAll('[data-tmp-quiz]').forEach(function (sec) {
      if (sec._tmp) return;
      sec._tmp = true;
      var steps = sec.querySelectorAll('[data-quiz-step]');
      var bar = sec.querySelector('[data-quiz-progress]');
      var result = sec.querySelector('[data-quiz-result]');
      var recs = sec.querySelector('[data-quiz-recs]');
      var votes = {}, order = [], step = 1;
      var segs = sec.querySelectorAll('.TmpQuiz__Seg li');
      var paint = function (n) {
        segs.forEach(function (li, i) { li.classList.toggle('is-done', i < n - 1); li.classList.toggle('is-active', i === n - 1); });
      };
      var show = function (n) {
        step = n;
        steps.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-quiz-step') === n); });
        paint(n);
      };
      var card = function (p, i) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        var price = Math.round(parseFloat(v.price) * 100);
        var img = p.images && p.images[0] ? p.images[0].src + (p.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
        return '<article class="TmpQuiz__Rec"><span class="TmpQuiz__RecTag">' + (i === 0 ? 'Your match' : 'Also for you') + '</span><a class="TmpQuiz__RecImg" href="/products/' + p.handle + '" tabindex="-1">' + (img ? '<img src="' + img + '" alt="" width="200" height="200" loading="lazy">' : '') + '</a>' +
          '<div class="TmpQuiz__RecBody"><a class="TmpQuiz__RecTitle" href="/products/' + p.handle + '"></a>' +
          '<p class="TmpQuiz__RecPrice"><strong>' + formatMoney(price) + '</strong> <s>' + formatMoney(Math.round(price * 2.5)) + '</s></p>' +
          '<div class="TmpQuiz__RecActions"><button type="button" class="TmpBtn TmpQuiz__Atc" data-id="' + v.id + '">Add</button><a class="TmpLink" href="/products/' + p.handle + '">View watch</a></div></div></article>';
      };
      var finish = function () {
        steps.forEach(function (s) { s.classList.remove('is-active'); });
        paint(steps.length + 1);
        result.hidden = false;
        recs.innerHTML = '<p class="TmpPicker__Empty">Searching…</p>';
        var ranked = Object.keys(votes).sort(function (a, b) { return votes[b] - votes[a] || order.indexOf(a) - order.indexOf(b); });
        Promise.all(ranked.slice(0, 4).map(function (h) {
          return fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=8').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
        })).then(function (lists) {
          var picked = [], seen = {};
          lists.forEach(function (l) {
            if (picked.length >= 2) return;
            var p = (l.products || []).filter(function (x) { return !seen[x.handle] && (x.variants || []).some(function (v) { return v.available; }); })[0];
            if (p) { seen[p.handle] = true; picked.push(p); }
          });
          recs.innerHTML = picked.map(card).join('') || '<p class="TmpPicker__Empty"><a href="/collections/bestsellers">View best sellers</a></p>';
          recs.querySelectorAll('.TmpQuiz__RecTitle').forEach(function (a, i) { a.textContent = picked[i].title; });
          recs.querySelectorAll('.TmpQuiz__Atc').forEach(function (b) {
            b.addEventListener('click', function () {
              var id = +b.getAttribute('data-id');
              b.disabled = true;
              addItems([{ id: id, quantity: 1 }]).then(function () { b.disabled = false; openCartDrawer(id); }).catch(function () { b.disabled = false; });
            });
          });
        });
      };
      sec.querySelectorAll('[data-quiz-answer]').forEach(function (b) {
        b.addEventListener('click', function () {
          (b.getAttribute('data-votes') || '').split(',').filter(Boolean).forEach(function (h, i) {
            votes[h] = (votes[h] || 0) + (i === 0 ? 1.2 : 1);
            if (order.indexOf(h) < 0) order.push(h);
          });
          b.classList.add('is-picked');
          setTimeout(function () { b.classList.remove('is-picked'); if (step < steps.length) show(step + 1); else finish(); }, 220);
        });
      });
      sec.querySelector('[data-quiz-restart]').addEventListener('click', function () { votes = {}; order = []; result.hidden = true; show(1); });
    });
  }

  /* ------------------------------------------------- delivery timeline */
  function initDelivery(root) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    (root || document).querySelectorAll('[data-tmp-delivery]').forEach(function (el) {
      var steps = (el.getAttribute('data-steps') || '0,1,4').split(',').map(function (n) { return parseInt(n, 10) || 0; });
      el.querySelectorAll('[data-delivery-date]').forEach(function (d, i) {
        var t = new Date(); t.setHours(12, 0, 0, 0); t.setDate(t.getDate() + (steps[i] || 0)); // calendar days
        d.textContent = days[t.getDay()] + ', ' + t.getDate() + ' ' + months[t.getMonth()];
      });
    });
  }

  /* ------------------------------------- video feature inside the product grid */
  // Sections with data-grid-after are moved into the collection grid after N products (N/2 on mobile,
  // min. 4) so the products stay above the fold. Hidden by CSS until placed (no layout shift on top).
  function initGridPlacement() {
    document.querySelectorAll('[data-grid-after]').forEach(function (sec) {
      if (sec.classList.contains('is-placed')) return;
      var grid = document.querySelector('.CollectionInner .ProductList--grid, .ProductListWrapper .ProductList--grid');
      var host = sec.closest('.shopify-section') || sec;
      if (!grid) { sec.classList.add('is-placed'); return; }
      var cells = Array.prototype.filter.call(grid.children, function (c) { return c.classList.contains('Grid__Cell'); });
      var n = parseInt(sec.getAttribute('data-grid-after'), 10) || 8;
      if (!window.matchMedia('(min-width: 1000px)').matches) n = Math.max(4, Math.round(n / 2));
      var cell = document.createElement('div');
      cell.className = 'Grid__Cell 1/1 TmpGridFeature';
      cell.appendChild(host);
      var ref = cells[Math.min(n, cells.length) - 1];
      if (ref && ref.nextSibling) grid.insertBefore(cell, ref.nextSibling); else grid.appendChild(cell);
      sec.classList.add('is-placed');
    });
  }

  /* ------------------------------------------- hero: desktop triptych */
  // Three vertical panels; each plays one clip and, near its end, fades to the next clip's poster,
  // swaps the source and fades back in. One hidden <video> pre-warms the next clip. Posters only with
  // reduced motion / Save-Data. Starts only when the hero is visible and the triptych is displayed.
  function initHeroTri(root) {
    (root || document).querySelectorAll('[data-tmp-hero-tri]').forEach(function (el) {
      if (el._tmp) return;
      el._tmp = true;
      var clips = (el.getAttribute('data-clips') || '').split('|').filter(Boolean);
      var posters = (el.getAttribute('data-posters') || '').split('|');
      var panels = Array.prototype.slice.call(el.querySelectorAll('[data-tri-panel]'));
      var pre = el.querySelector('.TmpHero__TriPreload');
      if (clips.length < 1 || panels.length < 3) return;
      var conn = navigator.connection || {};
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || conn.saveData === true) { el.classList.add('is-static'); return; }
      var fade = parseInt(el.getAttribute('data-fade'), 10) || 700;
      el.style.setProperty('--fade', fade + 'ms');
      var next = 0, started = false, visible = false;
      var warm = function (i) { if (pre && clips[i] && pre.getAttribute('src') !== clips[i]) { pre.src = clips[i]; pre.preload = 'auto'; pre.load(); } };
      var assign = function (panel, i) {
        var v = panel.querySelector('video'), img = panel.querySelector('img');
        panel._clip = i;
        if (img && posters[i]) img.src = posters[i];
        v.src = clips[i]; v.preload = 'auto'; v.load();
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        warm((i + 1) % clips.length);
      };
      var takeNext = function () { var i = next; next = (next + 1) % clips.length; return i; };
      panels.forEach(function (panel) {
        var v = panel.querySelector('video');
        v.addEventListener('playing', function () { panel.classList.add('is-on'); });
        v.addEventListener('timeupdate', function () {
          if (!v.duration || panel._swapping) return;
          if (v.duration - v.currentTime <= fade / 1000) {
            panel._swapping = true;
            panel.classList.remove('is-on');                       // fade to the next poster
            var i = takeNext();
            var img = panel.querySelector('img'); if (img && posters[i]) img.src = posters[i];
            setTimeout(function () { assign(panel, i); panel._swapping = false; }, fade);
          }
        });
        v.addEventListener('error', function () { if (visible) { var i = takeNext(); assign(panel, i); } });
      });
      var start = function () {
        if (started) return;
        started = true;
        panels.forEach(function (panel) { assign(panel, takeNext()); });
      };
      var pauseAll = function () { panels.forEach(function (p) { var v = p.querySelector('video'); if (v && !v.paused) v.pause(); }); };
      var resumeAll = function () { panels.forEach(function (p) { var v = p.querySelector('video'); if (v && v.getAttribute('src')) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } }); };
      var shown = function () { return getComputedStyle(el).display !== 'none'; };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible && shown()) { start(); resumeAll(); } else pauseAll();
          });
        }, { threshold: 0.15 }).observe(el);
      } else if (shown()) start();
      document.addEventListener('visibilitychange', function () { if (document.hidden) pauseAll(); else if (visible && shown()) resumeAll(); });
      window.addEventListener('resize', function () { if (visible && shown()) { start(); resumeAll(); } else pauseAll(); });
    });
  }

  /* ------------------------------------------------ hero: video sequence */
  // Two stacked <video>s: the visible one plays, the other preloads the next clip; crossfade on end.
  // Reduced motion / Save-Data: poster only.
  function initHeroReel(root) {
    (root || document).querySelectorAll('[data-tmp-hero-reel]').forEach(function (el) {
      if (el._tmp) return;
      el._tmp = true;
      var clips = (el.getAttribute('data-clips') || '').split('|').filter(Boolean);
      var vids = el.querySelectorAll('video');
      if (clips.length < 1 || vids.length < 2) return;
      var conn = navigator.connection || {};
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || conn.saveData === true) return;
      var fade = parseInt(el.getAttribute('data-fade'), 10) || 700;
      el.style.setProperty('--fade', fade + 'ms');
      var i = 0, cur = 0, playing = false;
      var load = function (v, src) { if (v.getAttribute('src') !== src) { v.src = src; v.preload = 'auto'; v.load(); } };
      var swap = function () {
        var nextV = vids[1 - cur], curV = vids[cur];
        i = (i + 1) % clips.length;
        load(nextV, clips[i]);
        var p = nextV.play(); if (p && p.catch) p.catch(function () {});
        nextV.classList.add('is-on'); curV.classList.remove('is-on');
        cur = 1 - cur;
        setTimeout(function () { curV.pause(); load(curV, clips[(i + 1) % clips.length]); }, fade + 50);
      };
      vids.forEach(function (v) {
        v.addEventListener('timeupdate', function () {
          if (v !== vids[cur] || !v.duration) return;
          if (v.duration - v.currentTime <= fade / 1000 && !v._swapped) { v._swapped = true; swap(); }
        });
        v.addEventListener('play', function () { v._swapped = false; });
        v.addEventListener('error', function () { if (v === vids[cur]) swap(); });
      });
      var start = function () {
        if (playing) return;
        playing = true;
        load(vids[0], clips[0]);
        if (clips.length > 1) load(vids[1], clips[1]);
        vids[0].classList.add('is-on');
        var p = vids[0].play(); if (p && p.catch) p.catch(function () { el.classList.add('is-static'); });
        el.classList.add('is-playing');
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && getComputedStyle(el).display !== 'none') { start(); if (vids[cur].paused && playing) vids[cur].play().catch(function () {}); } else if (playing) vids[cur].pause(); }); }, { threshold: 0.2 });
        io.observe(el);
      } else start();
      document.addEventListener('visibilitychange', function () { if (!playing) return; if (document.hidden) vids[cur].pause(); else vids[cur].play().catch(function () {}); });
    });
  }

  /* ------------------------------------------------ craft slider dots */
  function initCraft(root) {
    (root || document).querySelectorAll('[data-tmp-craft]').forEach(function (s) {
      if (s._tmpCraft) return;
      s._tmpCraft = true;
      var track = s.querySelector('[data-tmp-slider-track]');
      var dots = s.querySelectorAll('[data-craft-dot]');
      var sync = function () {
        var cells = track.querySelectorAll('[data-craft-stage]');
        if (!cells.length) return;
        var w = cells[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        var idx = Math.round(track.scrollLeft / w);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      };
      track.addEventListener('scroll', sync, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { var c = track.querySelectorAll('[data-craft-stage]')[i]; if (c) track.scrollTo({ left: c.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }); });
      sync();
    });
  }

  /* ------------------------------------------- offer triggers (landers) */
  function initOfferTriggers() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-offer-trigger]');
      if (!t) return;
      var id = t.getAttribute('data-offer-trigger');
      var fn = window.TempusOffers && window.TempusOffers[id];
      if (fn) { e.preventDefault(); fn(); }
      else { var sec = document.getElementById(id); if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target.closest && e.target.closest('[data-offer-trigger][role="button"]');
      if (t) { e.preventDefault(); t.click(); }
    });
  }

  /* ------------------------------------------------------------------ boot */
  function init(root) {
    if (!root) initGridPlacement();
    initFilms(root);
    initHeroTri(root);
    initHeroReel(root);
    initCraft(root);
    initDelivery(root);
    initAnatomy(root);
    initWrist(root);
    initCase(root);
    initWall(root);
    initQuiz(root);
    initLazyVideos(root);
    initReveal(root);
    initCountdowns(root);
    initAnnouncement(root);
    initReels(root);
    initBundles(root);
    initMbway(root);
    initOffers(root);
    initSliders(root);
  }

  window.Tempus = { formatMoney: formatMoney, init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initSticky(); initPriceRule(); initOfferTriggers(); initCardAtc(); initCartDiscount(); });
  } else { init(); initSticky(); initPriceRule(); initOfferTriggers(); initCardAtc(); initCartDiscount(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
